export enum DecisionListActionsEnum {
  DECISION_LIST_INIT_PAGE = 'DECISION_LIST_INIT_PAGE',
  DECISION_LIST_REMOVE_DECISIONS = 'DECISION_LIST_REMOVE_DECISIONS',
  DECISION_LIST_SET_SEARCH_VALUE = 'DECISION_LIST_SET_SEARCH_VALUE',
  DECISION_LIST_GET_DATA = 'DECISION_LIST_GET_DATA',
  DECISION_LIST_GET_DATA_NEXT_PAGE = 'DECISION_LIST_GET_DATA_NEXT_PAGE',
  DECISION_LIST_SET_DATA = 'DECISION_LIST_SET_DATA',
  DECISION_LIST_SET_ORDER = 'DECISION_LIST_SET_ORDER',
  DECISION_LIST_GET_DECISION_SELECT_OPTIONS = 'DECISION_LIST_GET_DECISION_SELECT_OPTIONS',
  DECISION_LIST_FIND_DECISION = 'DECISION_LIST_FIND_DECISION',
  DECISION_LIST_SET_FIND_DATA = 'DECISION_LIST_SET_FIND_DATA',
}
